import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Overline } from "@/components/motion";
import { useImg } from "@/lib/design";

export const PageHero = ({ over, title, lead, imgKey, image: custom, titleRec, testid }) => {
  const slotImage = useImg(imgKey);
  const image = custom || slotImage;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  const words = title.split(" ");
  const mid = Math.ceil(words.length / 2);
  return (
    <section ref={ref} data-testid={testid} className="relative overflow-hidden pb-16 pt-36 md:pb-24 md:pt-44">
      <div className="mx-auto grid max-w-[1400px] items-end gap-10 px-5 md:grid-cols-12 md:px-10">
        <div className="md:col-span-7">
          <Overline>{over}</Overline>
          <div data-ve-rec={titleRec}>
          <MaskLines
            onLoad
            as="h1"
            lines={[words.slice(0, mid).join(" "), words.slice(mid).join(" ")]}
            className="font-display mt-6 text-5xl font-semibold leading-[0.95] tracking-tight text-[#F4EEE2] sm:text-6xl lg:text-7xl"
          />
          </div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.5 }}
            className="mt-8 max-w-xl text-base leading-relaxed text-[#C9D0DB] md:text-lg"
          >
            {lead}
          </motion.p>
        </div>
        {image && (
          <div className="md:col-span-5">
            <motion.div
              initial={{ clipPath: "inset(100% 0 0 0)" }}
              animate={{ clipPath: "inset(0% 0 0 0)" }}
              transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
              className="relative h-[300px] overflow-hidden rounded-t-[999px] md:h-[440px]"
            >
              <motion.img style={{ y }} src={image} alt="" data-ve-img={imgKey} className="absolute inset-0 h-[120%] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B111E]/70 to-transparent" />
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
};
